import { render, staticRenderFns } from "./PoloRegister.vue?vue&type=template&id=6e8da405&scoped=true&"
import script from "./PoloRegister.vue?vue&type=script&lang=js&"
export * from "./PoloRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8da405",
  null
  
)

export default component.exports